import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroup } from 'react-bootstrap';
import { cloneDeep, get } from 'lodash';
import { AlignmentConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/AlignmentConfig';
import { BoldConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/BoldConfig';
import { ColorConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/ColorConfig';

export function ProductImpactSetting({ obj, handleChangeByPath }) {
  const { t } = useTranslation('common');
  const addobj = (path) => {
    const cloneObj = cloneDeep({ ...obj });
    const getArr = get(cloneObj, path, []);
    getArr.push({ title: '', value: '' });
    handleChangeByPath(getArr, path);
  };
  const removeObj = (i, path) => {
    const cloneObj = cloneDeep({ ...obj });
    const getArr = get(cloneObj, path, []);
    getArr.splice(i, 1);
    handleChangeByPath(getArr, path);
  };

  const resetFieldData = (type) => {
    handleChangeByPath(
      {
        type: 'item',
        id: '20',
        key: 'product_impact',
        label: 'Product Impact',
        supplierVisible: true,
        supplierEditable: true,
        properties: {
          productImpactType: type,
          subHeaderTitle: '',
          otherConfiguration: {
            subHeadAlignment: 'left',
            subHeadColour: 'black',
            subHeadbold: false,
          },
          productImpactDescription: '',
          globalWarmingPotential: '',
          globalWarmingPotentialBreakdown: [{ title: '', value: '' }],
          globalWarmingPotentialDescription: '',
          waterUsage: '',
          waterUsageBreakDown: [{ title: '', value: '' }],
          waterUsageDescription: '',
        },
        otherConfiguration: {
          alignment: 'left',
          colour: 'black',
          bold: false,
        },
      },
      null,
    );
  };

  const isAutoMated = useMemo(() => {
    if (obj?.properties?.productImpactType === 'automated') {
      return true;
    }
    return false;
  }, [obj?.properties?.productImpactType]);
  return (
    <>
      <FormGroup className="mb-24">
        <div className="d-flex align-items-center">
          <p className="custom-radio mb-0">
            <input
              type="radio"
              id="manual"
              value="manual"
              onChange={(e) => {
                resetFieldData('manual');
              }}
              name="manual"
              checked={obj?.properties?.productImpactType === 'manual'}
            />
            <label className="text-black text-bold" htmlFor="manual">
              {t('DPP.CONTROL.PRODUCT_IMPACT.MANUAL')}
            </label>
          </p>
          <p className="custom-radio mb-0 ml-4">
            <input
              type="radio"
              id="automated"
              value="automated"
              onChange={(e) => {
                resetFieldData('automated');
              }}
              name="automated"
              checked={obj?.properties?.productImpactType === 'automated'}
            />
            <label className="text-black text-bold" htmlFor="automated">
              {' '}
              {t('DPP.CONTROL.PRODUCT_IMPACT.AUTOMATED')}
            </label>
          </p>
        </div>
      </FormGroup>
      <FormGroup className="mb-0">
        <div className="common-input-control mb-0">
          <p className="f-16 text-bold field-name">{t('DPP.CONTROL.PRODUCT_IMPACT.SUB_HEADER_TITLE')}</p>
          <input
            type="text"
            className="form-control"
            value={obj?.properties?.subHeaderTitle}
            placeholder={t('DPP.CONTROL.PRODUCT_IMPACT.SUB_HEADER_PLACEHOLDER')}
            onChange={(e) => handleChangeByPath(e.target.value, 'properties.subHeaderTitle')}
            maxLength="40"
          />
        </div>
      </FormGroup>
      <div className="d-flex">
        <AlignmentConfig
          obj={obj?.properties}
          handleAlignment={(e) => handleChangeByPath(e.target.value, 'properties.otherConfiguration.subHeadAlignment')}
          dataName="subHeadAlignment"
        />
        <ColorConfig
          obj={obj?.properties}
          handleColor={(e) => handleChangeByPath(e.target.value, 'properties.otherConfiguration.subHeadColour')}
          dataName="subHeadColour"
        />
        <BoldConfig
          obj={obj?.properties}
          handleBold={(e) => handleChangeByPath(e.target.checked, 'properties.otherConfiguration.subHeadbold')}
          dataName="subHeadbold"
        />
      </div>

      <FormGroup>
        <p className="mt-2 mb-1 f-16 text-bold">{t('DPP.CONTROL.PRODUCT_IMPACT.PRODUCT_IMPACT_DESCRIPTION')}</p>
        <div className="d-flex">
          <AlignmentConfig obj={obj} handleAlignment={(e) => handleChangeByPath(e.target.value, 'otherConfiguration.alignment')} dataName="alignment" />
          <ColorConfig obj={obj} handleColor={(e) => handleChangeByPath(e.target.value, 'otherConfiguration.colour')} dataName="colour" />
          <BoldConfig obj={obj} handleBold={(e) => handleChangeByPath(e.target.checked, 'otherConfiguration.bold')} dataName="bold" />
        </div>
        <div className="form-group mb-24">
          <textarea
            name="comment"
            className="form-control custom-textarea"
            placeholder={t('DPP.ENTER_TEXT')}
            value={obj?.properties?.productImpactDescription}
            onChange={(e) => {
              handleChangeByPath(e.target.value, 'properties.productImpactDescription');
            }}
          />{' '}
        </div>
      </FormGroup>
      <FormGroup>
        <div className="common-input-control">
          <p className="field-name mb-2 ">
            {t('DPP.CONTROL.PRODUCT_IMPACT.GLOBAL_WARMING_POTENTIAL')} <span className="asterisk">*</span>
          </p>
          <div className="border-container">
            <input
              type={isAutoMated ? 'text' : 'number'}
              className="form-control"
              value={isAutoMated ? 'Autofill' : obj?.properties?.globalWarmingPotential}
              onChange={(e) => handleChangeByPath(e.target.value, 'properties.globalWarmingPotential')}
              disabled={isAutoMated}
            />
            <span className="unit">kg co2e</span>
          </div>
        </div>
      </FormGroup>
      <FormGroup>
        <div>
          <p className="mb-16 f-16 text-bold">{t('DPP.CONTROL.PRODUCT_IMPACT.GLOBAL_WARMING_POTENTIAL_BREAKDOWN')}</p>
          {obj?.properties?.globalWarmingPotentialBreakdown?.map((glo, i) => {
            return (
              <div className="breakdown-container mb-16" key={i}>
                <div className="common-input-control mb-0">
                  <p className="field-name">{t('DPP.CONTROL.PRODUCT_IMPACT.TITLE')}</p>
                  <input
                    type="text"
                    className="form-control"
                    value={isAutoMated ? 'AutoFill' : glo?.title}
                    placeholder={t('DPP.CONTROL.PRODUCT_IMPACT.TITLE_PLACEHOLDER')}
                    onChange={(e) => handleChangeByPath(e.target.value, `properties.globalWarmingPotentialBreakdown[${i}].title`)}
                    disabled={isAutoMated}
                  />
                </div>
                <div className="border-container sm ml-24">
                  <input
                    type={isAutoMated ? 'text' : 'number'}
                    className="form-control"
                    value={isAutoMated ? 'AutoFill' : glo?.value}
                    onChange={(e) => {
                      const newValue = Math.min(e.target.value, 100); // Ensures value doesn't exceed 100
                      handleChangeByPath(newValue, `properties.globalWarmingPotentialBreakdown[${i}].value`);
                    }}
                    disabled={isAutoMated}
                  />
                  <span className="unit">%</span>
                </div>
                {obj?.properties?.globalWarmingPotentialBreakdown?.length - 1 === i ? (
                  <button
                    type="button"
                    aria-label="Upload"
                    className="btn btn-outline sm ml-24"
                    onClick={() => addobj('properties.globalWarmingPotentialBreakdown')}
                  >
                    <i className="icon-Add-bold" />
                  </button>
                ) : (
                  <button
                    type="button"
                    aria-label="Upload"
                    className="btn btn-outline sm ml-24"
                    onClick={() => removeObj(i, 'properties.globalWarmingPotentialBreakdown')}
                  >
                    <i className="icon-Delete-bold" />
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </FormGroup>

      <FormGroup className="mt-24">
        <p className="mb-16 f-16 text-bold">{t('DPP.CONTROL.PRODUCT_IMPACT.GLOBAL_WARMING_DESCRIPTION')}</p>
        <div className="form-group mb-3 mt-2">
          <textarea
            name="comment"
            className="form-control custom-textarea"
            placeholder={t('DPP.ENTER_TEXT')}
            value={obj?.properties?.globalWarmingPotentialDescription}
            onChange={(e) => {
              handleChangeByPath(e.target.value, 'properties.globalWarmingPotentialDescription');
            }}
          />{' '}
        </div>
      </FormGroup>

      <FormGroup className="mt-24">
        <div className="common-input-control">
          <p className="field-name mb-2">
            {t('DPP.CONTROL.PRODUCT_IMPACT.WATER_USAGE')} <span className="asterisk">*</span>
          </p>
          <div className="border-container">
            <input
              type={isAutoMated ? 'text' : 'number'}
              className="form-control"
              value={isAutoMated ? 'Autofill' : obj?.properties?.waterUsage}
              disabled={isAutoMated}
              onChange={(e) => handleChangeByPath(e.target.value, 'properties.waterUsage')}
            />
            <span className="unit">Litres</span>
          </div>
        </div>
      </FormGroup>
      <FormGroup>
        <div>
          <p className="mb-16 f-16 text-bold">{t('DPP.CONTROL.PRODUCT_IMPACT.WATER_USAGE_BREAKDOWN')}</p>
          {obj?.properties?.waterUsageBreakDown?.map((wat, i) => {
            return (
              <div className="breakdown-container mb-16" key={i}>
                <div className="common-input-control mb-0">
                  <p className="field-name">{t('DPP.CONTROL.PRODUCT_IMPACT.TITLE')}</p>
                  <input
                    type="text"
                    className="form-control"
                    value={isAutoMated ? 'Autofill' : wat?.title}
                    placeholder={t('DPP.CONTROL.PRODUCT_IMPACT.TITLE_PLACEHOLDER')}
                    onChange={(e) => handleChangeByPath(e.target.value, `properties.waterUsageBreakDown[${i}].title`)}
                    disabled={isAutoMated}
                  />
                </div>
                <div className="border-container sm ml-24">
                  <input
                    type={isAutoMated ? 'text' : 'number'}
                    className="form-control"
                    value={isAutoMated ? 'Autofill' : wat?.value}
                    onChange={(e) => {
                      const newValue = Math.min(e.target.value, 100); // Ensures value doesn't exceed 100
                      handleChangeByPath(newValue, `properties.waterUsageBreakDown[${i}].value`);
                    }}
                    maxLength="40"
                    disabled={isAutoMated}
                  />
                  <span className="unit">%</span>
                </div>
                {obj?.properties?.waterUsageBreakDown?.length - 1 === i ? (
                  <button type="button" aria-label="Upload" className="btn btn-outline sm ml-24" onClick={() => addobj('properties.waterUsageBreakDown')}>
                    <i className="icon-Add-bold" />
                  </button>
                ) : (
                  <button type="button" aria-label="Upload" className="btn btn-outline sm ml-24" onClick={() => removeObj(i, 'properties.waterUsageBreakDown')}>
                    <i className="icon-Delete-bold" />
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </FormGroup>
      <FormGroup>
        <p className="mb-16 f-16 text-bold">{t('DPP.CONTROL.PRODUCT_IMPACT.WATER_USAGE_DESCRIPTION')}</p>
        <div className="form-group mb-3 mt-2">
          <textarea
            name="comment"
            className="form-control custom-textarea"
            placeholder={t('DPP.ENTER_TEXT')}
            value={obj?.properties?.waterUsageDescription}
            onChange={(e) => {
              handleChangeByPath(e.target.value, 'properties.waterUsageDescription');
            }}
          />{' '}
        </div>
      </FormGroup>
    </>
  );
}

export default ProductImpactSetting;
